function floatToString(t, e) {
    var o = t.toFixed(e).toString();
    return o.match(/^\.\d+/) ? "0" + o : o
}
$(() => {
    window.utils.enableDisclosure();
    let oldFlickityCreate = window.Flickity.prototype._create;
    window.Flickity.prototype._create = function() {
        let a = this;
        return this.element.addEventListener && this.element.addEventListener("load", () => {
            a.onresize()
        }, !0), this._create = oldFlickityCreate, oldFlickityCreate.apply(this, arguments)
    }, document.addEventListener("lazyloaded", a => {
        let b = a.target.getAttribute("data-bg"),
            c = a.target.getAttribute("data-mobile-bg");
        b && (window.PXUTheme.media_queries.medium.matches && c && (b = c), a.target.style.backgroundImage = `url(${b})`)
    }), window.imageFunctions.flickityIosFix(), window.objectFitImages(), window.header.init(), window.meganavManager.injectAll(), window.PXUTheme.theme_settings.enable_autocomplete && window.searchAutocomplete.init(), window.utils.initializeSectionWrapper(), window.slideshow.init(), window.testimonials.init(), window.video.init(), window.gallery.init(), window.videoFeature.setupVideoPlayer(), window.featuredPromotions.init(), window.featuredCollection.init(), window.collectionSidebarFilter.init(), window.cart.init(), window.map.init(), window.productPage.init(), window.productPage.runOptionSelector(), window.productPage.initializeQuantityBox(), window.recentlyViewed.init(), window.sidebarAccordions.init(), (window.PXUTheme.currency.show_multiple_currencies || window.PXUTheme.currency.native_multi_currency) && window.currencyConverter.init();
    let {
        pathname
    } = location;
    pathname.startsWith("/challenge") && $("html, body").animate({
        scrollTop: 0
    }, "slow");
    let resizeTimeout, beforeResizeWidth = $(window).width();
    window.addEventListener("resize", () => {
        resizeTimeout || (resizeTimeout = setTimeout(() => {
            resizeTimeout = null;
            let a = $(window).width();
            window.PXUTheme.media_queries.medium.matches && a !== beforeResizeWidth && (window.cart.init(), window.is_touch_device() || (window.header.unload(), window.header.init()));
            let b = document.querySelectorAll("[data-bg]");
            b.forEach(a => {
                let b = a.getAttribute("data-bg"),
                    c = a.getAttribute("data-mobile-bg");
                b && (window.PXUTheme.media_queries.medium.matches && c && (b = c), a.style.backgroundImage = `url(${b})`)
            })
        }, 66))
    }, !1), $.fancybox.defaults.animationEffect = "fade", $.fancybox.defaults.transitionEffect = "fade", $.fancybox.defaults.hash = !1, $.fancybox.defaults.infobar = !1, $.fancybox.defaults.toolbar = !1, $.fancybox.defaults.arrows = !1, $.fancybox.defaults.loop = !0, $.fancybox.defaults.smallBtn = !0, $.fancybox.defaults.live = !1, $.fancybox.defaults.zoom = !1, $.fancybox.defaults.mobile.preventCaptionOverlap = !1, $.fancybox.defaults.mobile.toolbar = !0, $.fancybox.defaults.mobile.buttons = ["close"], $.fancybox.defaults.mobile.clickSlide = "close", $.fancybox.defaults.mobile.clickContent = "zoom", $.fancybox.defaults.afterLoad = function(a, b) {
        "image" === a.current.type && b.$content.wrapInner("<div class='fancybox-image-wrap'></div>"), a.group.length > 1 && b.$content.find(".fancybox-image-wrap").append(`<a title="Previous" class="fancybox-item fancybox-nav fancybox-prev" href="javascript:;" data-fancybox-prev><span>${window.svgArrowSizeLeft}</span></a><a title="Next" class="fancybox-item fancybox-nav fancybox-next" href="javascript:;" data-fancybox-next><span>${svgArrowSizeRight}</span></a>`)
    }, $('.lightbox[rel="gallery"]').fancybox();
    let $videoIframes = $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"], iframe[src*="facebook.com/plugins/video"]');

    function getAspectRatio(width, height) {
        let ratio = width / height;
        return 0 === Math.abs(ratio - 1) ? "1:1" : Math.abs(ratio - 4 / 3) < Math.abs(ratio - 16 / 9) ? "4:3" : "16:9"
    }
    $videoIframes.each((d, b) => {
        let a = $(b),
            c = a.attr("src");
        a.parents(".plyr__video-wrapper").length || a.parents(".lazyframe").length || a.wrap(`<div class="lazyframe" data-ratio="${getAspectRatio(a.attr("width"),a.attr("height"))}" data-src="${c}"></div>`)
    }), window.lazyframe(".lazyframe"), $(".shopify-policy__container").wrap('<section class="section shopify-policy-template"><div class="container content"></div>'), $(".shopify-policy__container").addClass("five-eighths offset-by-three columns is-hidden-offset-mobile-only medium-down--one-whole"), $(".shopify-policy__title").append('<div class="feature_divider"></div>');
    let currentValue = $(".search__form input[name='q']").val();
    $(".search__form input[name='q']").length > 0 && $(".search__form input[name='q']").val(currentValue.replace("*", ""));
    let sortByEl = document.querySelector("[data-sort-by]");
    sortByEl && sortByEl.addEventListener("change", c => {
        let {
            target: a
        } = c, d = a.value;
        if (a) {
            let b = new URLSearchParams(document.location.search);
            b.set("sort_by", d), window.location.search = b
        }
    }), $("body").on("change", "#tag_filter", () => {
        $("[data-option-filter] input").prop("checked", !1), window.quickFilter.init()
    }), $("body").on("change", "#blog_filter", function() {
        let a = $(this).val();
        window.location = a
    }), $("input, select, textarea").on("focus blur", a => {
        $("meta[name=viewport]").attr("content", `width=device-width,initial-scale=1,maximum-scale=${"blur"===a.type?10:1}`)
    }), $("body").on("change", "[data-option-filter] input", () => {
        window.quickFilter.init(), $("html, body").animate({
            scrollTop: $(".content").offset().top
        }, 500)
    }), $("body").on("click", "[data-reset-filters]", () => {
        window.collectionSidebarFilter.clearAllFilters()
    }), $("body").on("click", "[data-clear-filter]", a => {
        let b = $(a.currentTarget),
            c = b.parents(".filter-active-tag");
        window.collectionSidebarFilter.clearSelectedFilter(c)
    }), $("body").on("change", ".currencies", () => {
        $("[data-initial-modal-price]").attr("data-initial-modal-price", "")
    }), $("body").on("change", ".js-quick-shop select", () => {
        let a = $('.js-quick-shop select[name="id"]').val();
        a && window.globalQuickShopProduct && window.quickShop.updateVariant(a)
    }), window.PXUTheme.theme_settings.quick_shop_enabled && window.quickShop.init();
    let touchStartPos = 0;
    if ($(document).bind("touchstart", () => {
            touchStartPos = $(window).scrollTop()
        }).bind("touchend", b => {
            let a = touchStartPos - $(window).scrollTop();
            (a > 20 || a < -20) && b.preventDefault
        }), $("body").on("click", ".sidebar .parent-link--false", function(b) {
            b.preventDefault();
            let a = $(this).parent("li");
            a.find(".menu-toggle").toggleClass("active"), a.find("ul").slideToggle()
        }), window.PXUTheme.theme_settings.newsletter_popup && window.newsletter_popup.init(), -1 !== window.location.pathname.indexOf("/comments") && $("html,body").animate({
            scrollTop: $("#new-comment").offset().top - 140
        }, "slow"), $("body").on("mouseenter", ".icon-search", () => {
            $(".search-terms").focus()
        }), $("body").on("click", ".icon-search", () => {
            $("input.search-terms").focus()
        }), $("body").on("click", ".search-submit", a => {
            let b = $(a.currentTarget);
            b.parent().submit()
        }), window.PXUTheme.media_queries.large.matches && ($(".animate_right").waypoint(function() {
            $(this.element).addClass("animated fadeInRight")
        }, {
            offset: "70%"
        }), $(".animate_left").waypoint(function() {
            $(this.element).addClass("animated fadeInLeft")
        }, {
            offset: "70%"
        }), $(".animate_up").waypoint(function() {
            $(this.element).addClass("animated fadeInUp")
        }, {
            offset: "70%"
        }), $(".animate_down").waypoint(function() {
            $(this.element).addClass("animated fadeInDown")
        }, {
            offset: "70%"
        })), $(".slider, .flexslider").find("li").unwrap(), $(".slider, .flexslider").flickity({
            pageDots: window.usePageDots,
            imagesLoaded: !0,
            arrowShape: window.arrowSize,
            lazyLoad: 2
        }), window.utils.createAccordion(".footer_menu", "h6", "ul"), window.utils.createAccordion(".footer_content", "h6", "div.toggle_content"), window.utils.createAccordion(".product_section .accordion-tabs", ".tabs li > a", ".tabs-content li"), window.utils.mobileParentActiveAccordion("#mobile_menu", "li.sublink > a.parent-link--true span", "li.sublink ul"), window.utils.mobileAccordion("#mobile_menu", "li.sublink > a.parent-link--false", "li.sublink ul"), window.utils.initializeTabs(), window.accordion.init(), $("body").on("click", ".menu-toggle", function() {
            let a = $(this).next("ul");
            a.slideToggle(), $(this).toggleClass("active"), $(this).attr("aria-expanded", "true" === $(this).attr("aria-expanded") ? "false" : "true")
        }), window.PXUTheme.theme_settings.collection_swatches && window.PXUTheme.media_queries.large.matches && ($("body").on("mouseenter", ".collection_swatches", function() {
            $(".swatch span", $(this)).each(function() {
                -1 === $(this).data("image").indexOf("no-image") && ($("<img/>")[0].src = $(this).data("image"))
            })
        }), $("body").on("mouseenter", ".swatch span", function() {
            -1 === $(this).data("image").indexOf("no-image") && ($(this).parents(".thumbnail").find(".image__container img:not(.secondary)").attr("src", $(this).data("image")), $(this).parents(".thumbnail").find(".image__container img:not(.secondary)").attr("srcset", $(this).data("image")))
        })), window.PXUTheme.theme_settings.display_tos_checkbox && $("body").on("click touchstart", ".cart_content .tos_label", function() {
            $(this).prev("input").prop("checked", !0)
        }), window.PXUTheme.theme_settings.display_tos_checkbox && window.PXUTheme.theme_settings.go_to_checkout ? $("body").on("click", ".tos_warning [data-cart-checkout-button]", function(a) {
            if ($(this).parents("form").find(".tos_agree").is(":checked")) window.PXUTheme.theme_settings.go_to_checkout || $("body").hasClass("cart") ? $(this).submit() : (a.preventDefault(), document.location.href = window.PXUTheme.routes.cart_url);
            else {
                let b = `<p class="warning animated bounceIn">${window.PXUTheme.translation.agree_to_terms_warning}</p>`;
                return 0 === $("p.warning").length && $(this).before(b), !1
            }
        }) : window.PXUTheme.theme_settings.go_to_checkout || $("body").on("click", ".cart_content [data-minicart-checkout-button]", a => {
            a.preventDefault(), document.location.href = window.PXUTheme.routes.cart_url
        }), window.PXUTheme.theme_settings.collection_secondary_image && window.imageFunctions.showSecondaryImage(), $("[data-is-required]").length) {
        let $checkboxGroup = $(".custom-contact__checkbox");
        $checkboxGroup.prop("required", !0), $checkboxGroup.on("change", () => {
            $checkboxGroup.prop("required", !0), $checkboxGroup.is(":checked") && $checkboxGroup.prop("required", !1)
        })
    }

    function ajaxSubmitCart(cart) {
        let $cart = cart;
        $.ajax({
            url: "/cart/update.js",
            dataType: "json",
            cache: !1,
            type: "post",
            data: $cart.serialize(),
            success(a) {
                refreshCart(a)
            }
        })
    }

    function updateCartItemQuantity(cartItem) {
        $.ajax({
            url: "/cart/change.js",
            dataType: "json",
            cache: !1,
            type: "post",
            data: {
                quantity: cartItem.quantity,
                line: cartItem.lineID
            },
            success(a) {
                let f = a.items,
                    b = cartItem.lineID - 1,
                    g = cartItem.parentCartForm.find("[data-variant-id]").length,
                    d = cartItem.parentCartForm.find(`[data-variant-id="${cartItem.variantID}"] input`),
                    e = 0,
                    c = 0,
                    h = void 0 !== a.items[b] ? a.items[b].quantity : 0;
                if (d.length > 1 ? ($.each(d, (b, a) => {
                        e += parseInt($(a).val())
                    }), f.forEach(a => {
                        a.variant_id === cartItem.variantID && (c += a.quantity)
                    })) : (e = parseInt(d.val()), c = void 0 !== a.items[b] ? a.items[b].quantity : 0), e > 0 && e > c) {
                    if (itemsLeftText = 1 === c ? window.PXUTheme.translation.one_item_left : window.PXUTheme.translation.items_left_text, $(".warning--quantity").remove(), g < f.length) "cart-template" === cartItem.parentCartForm.data("cart-form") ? cartItem.parentCartForm.submit() : refreshCart(a);
                    else {
                        let i = `<p class="warning warning--quantity animated bounceIn">${c} ${itemsLeftText}</p>`;
                        cartItem.parentCartForm.find(`[data-line-id='${cartItem.lineID}'] input`).parent().after(i), cartItem.parentCartForm.find(`[data-line-id='${cartItem.lineID}'] input`).val(h)
                    }
                } else "cart-template" === cartItem.parentCartForm.data("cart-form") ? cartItem.parentCartForm.submit() : refreshCart(a)
            }
        })
    }

    function refreshCartID() {
        let cartItem = document.querySelectorAll(".cart__item");
        for (let i = 0; i < cartItem.length; i++) {
            let lineIndex = i + 1,
                dataLineId = cartItem[i].querySelectorAll("[data-line-id]");
            for (let c = 0; c < dataLineId.length; c++) dataLineId[c].dataset.lineId = lineIndex
        }
    }

    function refreshCart(cart) {
        $(".cart_count").empty();
        let $cartBtn = $(".cart_count"),
            value = $cartBtn.text() || "0",
            cartItemsHTML = "",
            cartDiscountsHTML = "",
            cartActionHTML = "",
            cartSavingsHTML = "",
            $cartForm = $("[data-cart-form]"),
            productHasSale = !1,
            productCompareAtPrice = 0,
            productFinalPrice = 0;
        if ($cartForm.data("total-discount", cart.total_discount), $cartBtn.text(value.replace(/[0-9]+/, cart.item_count)), 0 === cart.item_count) $(".js-empty-cart__message").removeClass("hidden"), $cartForm.addClass("hidden");
        else {
            $(".js-empty-cart__message").addClass("hidden"), $cartForm.removeClass("hidden");
            let totalSaving = 0,
                saving = 0;
            $.each(cart.items, (g, a) => {
                let d = a.discounts,
                    e = "";
                for (let b = 0; b < d.length; b++) {
                    let {
                        title: h
                    } = d[b];
                    e = `<p class="notification-discount meta">${h}</p>`
                }
                let c = g + 1;
                if (cartItemsHTML += `<li class="mini-cart__item" data-cart-item data-line-id="${c}" data-variant-id="${a.id}"><a href="${a.url}">`, a.image && (cartItemsHTML += `<div class="cart_image"><img src="${a.image.replace(/(\.[^.]*)$/,"_compact$1").replace("http:","")}" alt="${htmlEncode(a.title)}" /></div></a>`), cartItemsHTML += `<div class="mini-cart__item-content"><div class="mini-cart__item-title"><a href="${a.url}">${a.title}</a>`, a.selling_plan_allocation && (cartItemsHTML += `<div class="meta">${a.selling_plan_allocation.selling_plan.name}</div>`), a.properties && $.each(a.properties, (b, a) => {
                        a && (cartItemsHTML += `<div class="line-item">${b}: ${a} </div>`)
                    }), cartItemsHTML += '</div><div class="mini-cart__item-price">', $.ajax({
                        dataType: "json",
                        async: !1,
                        cache: !1,
                        url: `/products/${a.handle}.js`,
                        success(e) {
                            let b = e;
                            if (b.variants) {
                                let c = b.variants;
                                if (c.length > 1)
                                    for (let d = 0; d < c.length; d++) c[d].id === a.id && (b = c[d])
                            }
                            b.compare_at_price ? b.compare_at_price > b.price && (productHasSale = !0, productCompareAtPrice = b.compare_at_price, productFinalPrice = b.price) : productHasSale = !1
                        }
                    }), !0 === productHasSale) {
                    let i = `${window.Shopify.formatMoney(productFinalPrice,$("body").data("money-format"))} </span><span class="money was_price">${window.Shopify.formatMoney(productCompareAtPrice,$("body").data("money-format"))}</span>`;
                    cartItemsHTML += `<span class="money sale">${i}</strong>`, totalSaving = (saving = (productCompareAtPrice - productFinalPrice) * a.quantity) + totalSaving
                } else if (a.price > a.final_price) {
                    let j = `${window.Shopify.formatMoney(a.final_price,$("body").data("money-format"))} </span><span class="money was_price">${window.Shopify.formatMoney(a.price,$("body").data("money-format"))}</span>`;
                    cartItemsHTML += `<span class="money sale">${j}</strong>`
                } else {
                    let k = window.Shopify.formatMoney(a.price, $("body").data("money-format"));
                    a.price > 0 ? cartItemsHTML += `<span class="money">${k}</span></strong>` : cartItemsHTML += `<span>${window.PXUTheme.translation.cart_free_text}</span></strong>`
                }
                if (cartItemsHTML += "</div>", a.unit_price_measurement && a.price > 0) {
                    let f = "";
                    1 !== a.unit_price_measurement.reference_value && (f = a.unit_price_measurement.reference_value), cartItemsHTML += `<p class="mini-cart__unit-price">${a.unit_price_measurement.quantity_value}${a.unit_price_measurement.quantity_unit} | ${Shopify.formatMoney(a.unit_price,$("body").data("money-format"))} / ${f}${a.unit_price_measurement.reference_unit}</p>`
                }
                a.price > a.final_price && (cartItemsHTML += e), cartItemsHTML += '<div class="product-quantity-box">', cartItemsHTML += '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>', cartItemsHTML += `<input type="number" min="0" class="quantity" name="updates[]" id="updates_${a.id}" value="${a.quantity}" data-cart-quantity-input="mini-cart" />`, cartItemsHTML += '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>', cartItemsHTML += "</div></div></div>", cartItemsHTML += `<a href="/cart/change?line=${c}&amp;quantity=0" class="js-cart-remove-btn cart__remove-btn" data-line-id="${c}" data-remove-item="mini-cart"><span class="remove-icon"></span></a>`
            });
            let cartDiscounts = cart.cart_level_discount_applications;
            for (let i = 0; i < cartDiscounts.length; i++) {
                let amount = window.Shopify.formatMoney(cartDiscounts[i].total_allocated_amount, $("body").data("money-format")),
                    {
                        title
                    } = cartDiscounts[i];
                cartDiscountsHTML += `<span class="cart_discounts--title">${title}</span>`, cartDiscountsHTML += '<span class="cart_discounts--price">', cartDiscountsHTML += `-<span class="money">${amount}</span></span>`
            }
            cartActionHTML += `<span class="right"><span class="money">${window.Shopify.formatMoney(cart.total_price,$("body").data("money-format"))}</span></span> <span>${window.PXUTheme.translation.cart_subtotal_text}</span>`, totalSaving += cart.total_discount, cartSavingsHTML = window.PXUTheme.theme_settings.display_savings && totalSaving > 0 ? `<span class="right"><span class="money">${window.Shopify.formatMoney(totalSaving,$("body").data("money-format"))}</span></span><span>${window.PXUTheme.translation.cart_savings_text}</span>` : ""
        }
        $(".js-cart_items").html(cartItemsHTML), $(".js-cart_discounts").html(cartDiscountsHTML), $(".js-cart_subtotal").html(cartActionHTML), $(".js-cart_savings").html(cartSavingsHTML), window.PXUTheme.currency.show_multiple_currencies && window.currencyConverter.convertCurrencies()
    }
    $(".maps").click(() => {
        $(".maps iframe").css("pointer-events", "auto")
    }), "load_more" === window.PXUTheme.theme_settings.pagination_type && window.enableLoadMoreProducts(), "load_more_button" === window.PXUTheme.theme_settings.pagination_type && window.enableLoadMoreButton(".product-list"), "infinite_scroll" === window.PXUTheme.theme_settings.pagination_type && window.enableInfiniteScroll(".product-list"), $("body").on("change", "[data-cart-quantity-input]", function() {
        let a = {
            lineID: $(this).parents("[data-cart-item]").data("line-id"),
            variantID: $(this).parents("[data-cart-item]").data("variant-id"),
            quantity: $(this).val(),
            parentCartForm: $(this).parents("[data-cart-form]"),
            totalDiscount: $(this).parents("[data-cart-form]").data("total-discount"),
            $element: $(this).parents("[data-cart-item]")
        };
        $(this).parents(".product-quantity-box").find(".js-change-quantity").addClass("is-disabled"), updateCartItemQuantity(a)
    }), $("body").on("click", "[data-remove-item]", function(b) {
        b.preventDefault();
        let a = {
            lineID: $(this).parents("[data-cart-item]").data("line-id"),
            variantID: $(this).parents("[data-cart-item]").data("variant-id"),
            quantity: 0,
            parentCartForm: $(this).parents("[data-cart-form]"),
            totalDiscount: $(this).parents("[data-cart-form]").data("total-discount"),
            $element: $(this).parents("[data-cart-item]")
        };
        a.$element.addClass("animated fadeOutLeft"), updateCartItemQuantity(a), "cart-template" === a.parentCartForm.data("cart-form") && (a.$element.find("input").val("0"), a.parentCartForm.submit()), "mini-cart" === a.parentCartForm.data("cart-form") && a.$element.find("input").val("0")
    }), "ajax" === window.PXUTheme.theme_settings.cart_action && $(document).on("click", ".ajax-submit", function(e) {
        e.preventDefault();
        let $addToCartForm = $(this).closest("form"),
            $addToCartBtn = $addToCartForm.find(".add_to_cart");
        return $("body").hasClass("cart") && $addToCartForm.submit(), $.ajax({
            url: "/cart/add.js",
            dataType: "json",
            cache: !1,
            type: "post",
            data: $addToCartForm.serialize(),
            beforeSend() {
                $addToCartBtn.attr("disabled", "disabled").addClass("disabled"), $addToCartBtn.find("span").removeClass("fadeInDown").addClass("animated zoomOut")
            },
            success() {
                $addToCartBtn.find(".checkmark").addClass("checkmark-active"), window.setTimeout(() => {
                    $addToCartBtn.removeAttr("disabled").removeClass("disabled"), $addToCartBtn.find(".checkmark").removeClass("checkmark-active"), $addToCartBtn.find("span").removeClass("zoomOut").addClass("fadeInDown")
                }, 1e3), $.ajax({
                    url: "/cart.js",
                    dataType: "json",
                    cache: !1,
                    success(a) {
                        setTimeout(function() {
                            if (refreshCart(a), $("body").hasClass("fancybox-active") && $.fancybox.close(), $("#header").is(":visible") ? $("#header .cart-container").addClass("active_link") : $(".sticky_nav--stick").length ? $(".sticky_nav .cart-container").addClass("active_link") : $(".top-bar .cart-container").addClass("active_link"), window.PXUTheme.media_queries.medium.matches) {
                                let b = $(this).parent();
                                b.hasClass("active_link"), $("body").addClass("blocked-scroll");
                                let c = document.getElementById("header");
                                c.classList.contains("mobile_nav-fixed--false") && window.scroll({
                                    top: 0,
                                    left: 0,
                                    behavior: "smooth"
                                })
                            }
                        }, 500)
                    }
                })
            },
            error(XMLHttpRequest) {
                let response = eval(`(${XMLHttpRequest.responseText})`);
                response = response.description, $(".warning").remove();
                let warning = `<p class="warning animated bounceIn">${response.replace("All 1 ","All ")}</p>`;
                $addToCartForm.after(warning), $addToCartBtn.removeAttr("disabled").removeClass("disabled"), $addToCartBtn.find("span").text(window.PXUTheme.translation.add_to_cart).removeClass("zoomOut").addClass("zoomIn")
            }
        }), !1
    }), window.productPage.productSwatches()
}), window.Shopify.updateOptionsInSelector = function(c, a) {
    switch (c) {
        case 0:
            var b = "root";
            break;
        case 1:
            var b = $(`${a} .single-option-selector:eq(0)`).val();
            break;
        case 2:
            var b = $(`${a} .single-option-selector:eq(0)`).val();
            b += ` / ${$(`${a} .single-option-selector:eq(1)`).val()}`
    }
    let d = Shopify.optionsMap[b];
    $(`${a} .swatch[data-option-index="${c}"] .swatch-element`).each(function() {
        -1 !== $.inArray($(this).attr("data-value"), d) ? $(this).removeClass("soldout").find(":radio").removeAttr("disabled", "disabled").removeAttr("checked") : $(this).addClass("soldout").find(":radio").removeAttr("checked").attr("disabled", "disabled")
    })
}, window.Shopify.linkOptionSelectors = function(b, c) {
    window.Shopify.optionsMap = {};
    for (let f = 0; f < b.variants.length; f++) {
        let a = b.variants[f];
        if (a.available) {
            if (window.Shopify.optionsMap.root = window.Shopify.optionsMap.root || [], window.Shopify.optionsMap.root.push(a.option1), window.Shopify.optionsMap.root = window.Shopify.uniq(window.Shopify.optionsMap.root), b.options.length > 1) {
                let d = a.option1;
                window.Shopify.optionsMap[d] = window.Shopify.optionsMap[d] || [], window.Shopify.optionsMap[d].push(a.option2), window.Shopify.optionsMap[d] = window.Shopify.uniq(window.Shopify.optionsMap[d])
            }
            if (3 === b.options.length) {
                let e = `${a.option1} / ${a.option2}`;
                window.Shopify.optionsMap[e] = window.Shopify.optionsMap[e] || [], window.Shopify.optionsMap[e].push(a.option3), window.Shopify.optionsMap[e] = window.Shopify.uniq(window.Shopify.optionsMap[e])
            }
        }
    }
    window.Shopify.updateOptionsInSelector(0, c), b.options.length > 1 && window.Shopify.updateOptionsInSelector(1, c), 3 === b.options.length && window.Shopify.updateOptionsInSelector(2, c), $(`${c} .single-option-selector:eq(0)`).change(() => (window.Shopify.updateOptionsInSelector(1, c), 3 === b.options.length && window.Shopify.updateOptionsInSelector(2, c), !0)), $(`${c} .single-option-selector:eq(1)`).change(() => (3 === b.options.length && window.Shopify.updateOptionsInSelector(2, c), !0))
}, window.htmlEncode = function(a) {
    return a ? $("<div/>").text(a).html() : ""
}, window.is_touch_device = function() {
    return "ontouchstart" in window || navigator.maxTouchPoints
}, window.touch_device = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent), void 0 === window.Shopify && (window.Shopify = {}), window.Shopify.each = function(b, c) {
    for (var a = 0; a < b.length; a++) c(b[a], a)
}, window.Shopify.map = function(b, d) {
    for (var c = [], a = 0; a < b.length; a++) c.push(d(b[a], a));
    return c
}, window.Shopify.arrayIncludes = function(b, c) {
    for (var a = 0; a < b.length; a++)
        if (b[a] == c) return !0;
    return !1
}, window.Shopify.uniq = function(b) {
    for (var c = [], a = 0; a < b.length; a++) window.Shopify.arrayIncludes(c, b[a]) || c.push(b[a]);
    return c
}, window.Shopify.isDefined = function(a) {
    return void 0 !== a
}, window.Shopify.getClass = function(a) {
    return Object.prototype.toString.call(a).slice(8, -1)
}, window.Shopify.extend = function(a, b) {
    function c() {}
    c.prototype = b.prototype, a.prototype = new c, a.prototype.constructor = a, a.baseConstructor = b, a.superClass = b.prototype
}, window.Shopify.locationSearch = function() {
    return window.location.search
}, window.Shopify.locationHash = function() {
    return window.location.hash
}, window.Shopify.replaceState = function(a) {
    window.history.replaceState({}, document.title, a)
}, window.Shopify.urlParam = function(b) {
    var a = RegExp("[?&]" + b + "=([^&#]*)").exec(window.Shopify.locationSearch());
    return a && decodeURIComponent(a[1].replace(/\+/g, " "))
}, window.Shopify.newState = function(a, b) {
    var c;
    return (c = window.Shopify.urlParam(a) ? window.Shopify.locationSearch().replace(RegExp("(" + a + "=)[^&#]+"), "$1" + b) : "" === window.Shopify.locationSearch() ? "?" + a + "=" + b : window.Shopify.locationSearch() + "&" + a + "=" + b) + window.Shopify.locationHash()
}, window.Shopify.setParam = function(a, b) {
    window.Shopify.replaceState(window.Shopify.newState(a, b))
}, window.Shopify.Product = function(a) {
    window.Shopify.isDefined(a) && this.update(a)
}, window.Shopify.Product.prototype.update = function(a) {
    for (property in a) this[property] = a[property]
}, window.Shopify.Product.prototype.optionNames = function() {
    return "Array" == window.Shopify.getClass(this.options) ? this.options : []
}, window.Shopify.Product.prototype.optionValues = function(b) {
    if (!window.Shopify.isDefined(this.variants)) return null;
    var a = window.Shopify.map(this.variants, function(a) {
        var c = "option" + (b + 1);
        return void 0 == a[c] ? null : a[c]
    });
    return null == a[0] ? null : window.Shopify.uniq(a)
}, window.Shopify.Product.prototype.getVariant = function(a) {
    var b = null;
    return a.length != this.options.length || window.Shopify.each(this.variants, function(d) {
        for (var e = !0, c = 0; c < a.length; c++) d["option" + (c + 1)] != a[c] && (e = !1);
        return 1 == e ? void(b = d) : void 0
    }), b
}, window.Shopify.Product.prototype.getVariantById = function(c) {
    for (var a = 0; a < this.variants.length; a++) {
        var b = this.variants[a];
        if (c == b.id) return b
    }
    return null
}, window.Shopify.money_format = "$", window.Shopify.formatMoney = function(a, f) {
    function g(a, b) {
        return void 0 === a ? b : a
    }

    function c(a, b, c, d) {
        if (b = g(b, 2), c = g(c, ","), d = g(d, "."), isNaN(a) || null == a) return 0;
        var e = (a = (a / 100).toFixed(b)).split("."),
            f = e[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + c),
            h = e[1] ? d + e[1] : "";
        return f + h
    }
    "string" == typeof a && (a = a.replace(".", ""));
    var b = "",
        d = /\{\{\s*(\w+)\s*\}\}/,
        e = f || this.money_format;
    switch (e.match(d)[1]) {
        case "amount":
            b = c(a, 2);
            break;
        case "amount_no_decimals":
            b = c(a, 0);
            break;
        case "amount_with_comma_separator":
            b = c(a, 2, ".", ",");
            break;
        case "amount_with_apostrophe_separator":
            b = c(a, 2, "'", ".");
            break;
        case "amount_no_decimals_with_comma_separator":
            b = c(a, 0, ".", ",")
    }
    return e.replace(d, b)
}, window.Shopify.OptionSelectors = function(b, a) {
    return this.selectorDivClass = "selector-wrapper", this.selectorClass = "single-option-selector", this.variantIdFieldIdSuffix = "-variant-id", this.variantIdField = null, this.historyState = null, this.selectors = [], this.domIdPrefix = b, this.product = new window.Shopify.Product(a.product), this.onVariantSelected = window.Shopify.isDefined(a.onVariantSelected) ? a.onVariantSelected : function() {}, this.replaceSelector(b), this.initDropdown(), a.enableHistoryState && (this.historyState = new window.Shopify.OptionSelectors.HistoryState(this)), !0
}, window.Shopify.OptionSelectors.prototype.initDropdown = function() {
    var a = {
        initialLoad: !0
    };
    if (!this.selectVariantFromDropdown(a)) {
        var b = this;
        setTimeout(function() {
            b.selectVariantFromParams(a) || b.fireOnChangeForFirstDropdown.call(b, a)
        })
    }
}, window.Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown = function(a) {
    this.selectors[0].element.onchange(a)
}, window.Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown = function(a) {
    this.selectVariantFromParams(a) || this.selectVariantFromDropdown(a)
}, window.Shopify.OptionSelectors.prototype.replaceSelector = function(b) {
    var a = document.getElementById(b),
        c = a.parentNode;
    window.Shopify.each(this.buildSelectors(), function(b) {
        c.insertBefore(b, a)
    }), a.style.display = "none", this.variantIdField = a
}, window.Shopify.OptionSelectors.prototype.selectVariantFromDropdown = function(b) {
    var a = document.getElementById(this.domIdPrefix).querySelector("[selected]");
    if (a || (a = document.getElementById(this.domIdPrefix).querySelector('[selected="selected"]')), !a) return !1;
    var c = a.value;
    return this.selectVariant(c, b)
}, window.Shopify.OptionSelectors.prototype.selectVariantFromParams = function(a) {
    var b = window.Shopify.urlParam("variant");
    return this.selectVariant(b, a)
}, window.Shopify.OptionSelectors.prototype.selectVariant = function(f, d) {
    var e = this.product.getVariantById(f);
    if (null == e) return !1;
    for (var a = 0; a < this.selectors.length; a++) {
        var b = this.selectors[a].element,
            c = e[b.getAttribute("data-option")];
        null != c && this.optionExistInSelect(b, c) && (b.value = c)
    }
    return "undefined" != typeof jQuery ? jQuery(this.selectors[0].element).trigger("change", d) : this.selectors[0].element.onchange(d), !0
}, window.Shopify.OptionSelectors.prototype.optionExistInSelect = function(b, c) {
    for (var a = 0; a < b.options.length; a++)
        if (b.options[a].value == c) return !0
}, window.Shopify.OptionSelectors.prototype.insertSelectors = function(b, a) {
    window.Shopify.isDefined(a) && this.setMessageElement(a), this.domIdPrefix = "product-" + this.product.id + "-variant-selector";
    var c = document.getElementById(b);
    window.Shopify.each(this.buildSelectors(), function(a) {
        c.appendChild(a)
    })
}, window.Shopify.OptionSelectors.prototype.buildSelectors = function() {
    for (var a = 0; a < this.product.optionNames().length; a++) {
        var b = new window.Shopify.SingleOptionSelector(this, a, this.product.optionNames()[a], this.product.optionValues(a));
        b.element.disabled = !1, this.selectors.push(b)
    }
    var c = this.selectorDivClass,
        d = this.product.optionNames();
    return window.Shopify.map(this.selectors, function(b) {
        var a = document.createElement("div");
        if (a.setAttribute("class", c), d.length > 1) {
            var e = document.createElement("label");
            e.htmlFor = b.element.id, e.innerHTML = b.name, a.appendChild(e)
        }
        return a.appendChild(b.element), a
    })
}, window.Shopify.OptionSelectors.prototype.selectedValues = function() {
    for (var b = [], a = 0; a < this.selectors.length; a++) {
        var c = this.selectors[a].element.value;
        b.push(c)
    }
    return b
}, window.Shopify.OptionSelectors.prototype.updateSelectors = function(d, b) {
    var c = this.selectedValues(),
        a = this.product.getVariant(c);
    a ? (this.variantIdField.disabled = !1, this.variantIdField.value = a.id) : this.variantIdField.disabled = !0, this.onVariantSelected(a, this, b), null != this.historyState && this.historyState.onVariantChange(a, this, b)
}, window.Shopify.OptionSelectorsFromDOM = function(b, a) {
    var c = a.optionNames || [],
        d = a.priceFieldExists || !0,
        e = a.delimiter || "/",
        f = this.createProductFromSelector(b, c, d, e);
    a.product = f, window.Shopify.OptionSelectorsFromDOM.baseConstructor.call(this, b, a)
}, window.Shopify.extend(window.Shopify.OptionSelectorsFromDOM, window.Shopify.OptionSelectors), window.Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector = function(g, c, d, e) {
    if (!window.Shopify.isDefined(d)) var d = !0;
    if (!window.Shopify.isDefined(e)) var e = "/";
    var f = document.getElementById(g),
        h = f.childNodes,
        i = (f.parentNode, c.length),
        j = [];
    window.Shopify.each(h, function(a, k) {
        if (1 == a.nodeType && "option" == a.tagName.toLowerCase()) {
            var b = a.innerHTML.split(new RegExp("\\s*\\" + e + "\\s*"));
            0 == c.length && (i = b.length - (d ? 1 : 0));
            var f = b.slice(0, i),
                g = d ? b[i] : "",
                h = (a.getAttribute("value"), {
                    available: !a.disabled,
                    id: parseFloat(a.value),
                    price: g,
                    option1: f[0],
                    option2: f[1],
                    option3: f[2]
                });
            j.push(h)
        }
    });
    var a = {
        variants: j
    };
    if (0 == c.length) {
        a.options = [];
        for (var b = 0; i > b; b++) a.options[b] = "option " + (b + 1)
    } else a.options = c;
    return a
}, window.Shopify.SingleOptionSelector = function(e, c, f, a) {
    this.multiSelector = e, this.values = a, this.index = c, this.name = f, this.element = document.createElement("select");
    for (var b = 0; b < a.length; b++) {
        var d = document.createElement("option");
        d.value = a[b], d.innerHTML = a[b], this.element.appendChild(d)
    }
    return this.element.setAttribute("class", this.multiSelector.selectorClass), this.element.setAttribute("data-option", "option" + (c + 1)), this.element.id = e.domIdPrefix + "-option-" + c, this.element.onchange = function(b, a) {
        a = a || {}, e.updateSelectors(c, a)
    }, !0
}, window.Shopify.Image = {
    preload: function(b, c) {
        for (var a = 0; a < b.length; a++) {
            var d = b[a];
            this.loadImage(this.getSizedImageUrl(d, c))
        }
    },
    loadImage: function(a) {
        (new Image).src = a
    },
    switchImage: function(b, a, c) {
        if (b && a) {
            var e = this.imageSize(a.src),
                d = this.getSizedImageUrl(b.src, e);
            c ? c(d, b, a) : a.src = d
        }
    },
    imageSize: function(b) {
        var a = b.match(/_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./);
        return null != a ? a[1] : null
    },
    getSizedImageUrl: function(a, b) {
        if (null == b) return a;
        if ("master" == b) return this.removeProtocol(a);
        var c = a.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
        if (null != c) {
            var d = a.split(c[0]),
                e = c[0];
            return this.removeProtocol(d[0] + "_" + b + e)
        }
        return null
    },
    removeProtocol: function(a) {
        return a.replace(/http(s)?:/, "")
    }
}, window.Shopify.OptionSelectors.HistoryState = function(a) {
    this.browserSupports() && this.register(a)
}, window.Shopify.OptionSelectors.HistoryState.prototype.register = function(a) {
    window.addEventListener("popstate", function(b) {
        a.selectVariantFromParamsOrDropdown({
            popStateCall: !0
        })
    })
}, window.Shopify.OptionSelectors.HistoryState.prototype.onVariantChange = function(a, c, b) {
    this.browserSupports() && (!a || b.initialLoad || b.popStateCall || window.Shopify.setParam("variant", a.id))
}, window.Shopify.OptionSelectors.HistoryState.prototype.browserSupports = function() {
    return window.history && window.history.replaceState
}, $(document).on("shopify:block:select", function(b) {
    var c = b.detail.blockId,
        a = $("#shopify-section-" + b.detail.sectionId);
    (a.hasClass("shopify-section--slideshow") || a.hasClass("shopify-section--testimonials")) && sliderBlock.select(c, a)
}), $(document).on("shopify:block:deselect", function(b) {
    var a = $("#shopify-section-" + b.detail.sectionId);
    (a.hasClass("shopify-section--slideshow") || a.hasClass("shopify-section--testimonials")) && window.sliderBlock.deselect(a)
}), $(document).on("shopify:section:reorder", function(a) {
    window.utils.initializeSectionWrapper()
}), $(document).on("shopify:section:load", function(b) {
    var a = $("#shopify-section-" + b.detail.sectionId);
    window.utils.initializeSectionWrapper(), window.utils.enableDisclosure(), window.PXUTheme.theme_settings.enable_autocomplete && window.searchAutocomplete.init(), window.PXUTheme.theme_settings.newsletter_popup && window.newsletter_popup.init(), a.hasClass("shopify-section--article-template") && window.sidebarAccordions.init(), a.hasClass("shopify-section--blog-template") && window.sidebarAccordions.init(), a.hasClass("shopify-section--product-sidebar") && window.sidebarAccordions.init(), a.hasClass("shopify-section--page-gallery-template") && window.gallery.init(a), a.hasClass("shopify-section--gallery") && window.gallery.init(), (a.hasClass("shopify-section--page-faq-template") || a.hasClass("shopify-section--faq")) && window.accordion.init(), a.hasClass("shopify-section--cart-template") && window.cart.init(), a.hasClass("shopify-section--featured-promotions") && window.featuredPromotions.init(), a.hasClass("shopify-section--slideshow") && window.slideshow.init(), a.hasClass("shopify-section--testimonials") && window.testimonials.init(), a.hasClass("shopify-section--featured-product") && (window.productPage.init(), window.productPage.runOptionSelector(a), window.videoFeature.init(), window.productPage.productSwatches()), a.hasClass("shopify-section--map") && window.map.init(), a.hasClass("shopify-section--featured-collection") && (window.featuredCollection.init(), window.productPage.init(), window.productPage.runOptionSelector(a), window.videoFeature.init()), a.hasClass("shopify-section--video") && window.video.init(), (a.hasClass("shopify-section--product-template") || a.hasClass("shopify-section--quick-shop")) && (window.productPage.init(), window.productPage.runOptionSelector(a), window.videoFeature.init(), window.productPage.productSwatches(), window.recentlyViewed.init()), a.hasClass("shopify-section--recommended-products") && window.productPage.init(), a.hasClass("shopify-section--recently-viewed-products") && window.recentlyViewed.init(), a.hasClass("shopify-section--article-template") && -1 != window.location.pathname.indexOf("/comments") && $("html,body").animate({
        scrollTop: $("#new-comment").offset().top - 140
    }, "slow"), a.hasClass("shopify-section--collection-template") && (window.collectionSidebarFilter.init(), window.productPage.init(), window.productPage.runOptionSelector(a), window.sidebarAccordions.init(), window.recentlyViewed.init()), a.hasClass("shopify-section--contact-section") && window.map.init(), a.hasClass("shopify-section--search-template") && (window.PXUTheme.theme_settings.enable_autocomplete && window.searchAutocomplete.init(), window.collectionSidebarFilter.init(), window.sidebarAccordions.init()), a.hasClass("shopify-section--header") && (window.meganavManager.injectAll(), window.header.init()), a.hasClass("shopify-section--mega-menu") && window.meganavManager.add(a[0])
}), $(document).on("shopify:section:unload", function(c) {
    var b = $(c.target),
        a = $("#shopify-section-" + c.detail.sectionId);
    a.hasClass("shopify-section--header") && window.header.unload(b), a.hasClass("shopify-section--slideshow") && window.slideshow.unload(b), a.hasClass("shopify-section--testimonials") && window.testimonials.unload(b), a.hasClass("shopify-section--search") && window.searchAutocomplete.unload(b), a.hasClass("shopify-section--product-template") && window.productPage.unload(a), a.hasClass("shopify-section--featured-product") && window.productPage.unload(a), a.hasClass("shopify-section--mega-menu") && window.meganavManager.remove(a[0]), window.requestAnimationFrame(() => {
        window.utils.initializeSectionWrapper()
    })
}), $(document).on("shopify:section:select", function(c) {
    var a = $("#shopify-section-" + c.detail.sectionId);
    a.hasClass("shopify-section--mega-menu") && window.meganavManager.select(a[0]), a.hasClass("shopify-section--featured-collection") && (window.featuredCollection.unload(a), window.featuredCollection.init());
    var b = document.createEvent("UIEvents");
    b.initUIEvent("resize", !0, !1, window, 0), window.dispatchEvent(b)
}), $(document).on("shopify:section:deselect", function(a) {
    $("#shopify-section-" + a.detail.sectionId).hasClass("shopify-section--mega-menu") && window.meganavManager.deselect()
})